import {
  GET_USER_WALLET,
  GET_USER_WALLET_SUCCESS,
  GET_USER_WALLET_FAILURE,
  CREATE_FUNDING_INTENT,
  CREATE_FUNDING_INTENT_SUCCESS,
  CREATE_FUNDING_INTENT_FAILURE,
  INITIALIZE_FUNDING_PAYMENT,
  INITIALIZE_FUNDING_PAYMENT_SUCCESS,
  INITIALIZE_FUNDING_PAYMENT_FAILURE,
  VERIFY_FUNDING_PAYMENT,
  VERIFY_FUNDING_PAYMENT_SUCCESS,
  VERIFY_FUNDING_PAYMENT_FAILURE,
  GET_WALLET_HISTORY,
  GET_WALLET_HISTORY_SUCCESS,
  GET_WALLET_HISTORY_FAILURE,
  GET_ADMIN_WALLET_HISTORY,
  GET_ADMIN_WALLET_HISTORY_SUCCESS,
  GET_ADMIN_WALLET_HISTORY_FAILURE,
  PROCESS_WALLET_REFUND,
  PROCESS_WALLET_REFUND_SUCCESS,
  PROCESS_WALLET_REFUND_FAILURE,
  PROCESS_WALLET_REWARD,
  PROCESS_WALLET_REWARD_SUCCESS,
  PROCESS_WALLET_REWARD_FAILURE,
  GET_CUSTOMER_WALLETS,
  GET_CUSTOMER_WALLETS_SUCCESS,
  GET_CUSTOMER_WALLETS_FAILURE,
  GET_CASHBACK_RULES,
  GET_CASHBACK_RULES_SUCCESS,
  GET_CASHBACK_RULES_FAILURE,
  CREATE_CASHBACK_RULE,
  CREATE_CASHBACK_RULE_SUCCESS,
  CREATE_CASHBACK_RULE_FAILURE,
  UPDATE_CASHBACK_RULE,
  UPDATE_CASHBACK_RULE_SUCCESS,
  UPDATE_CASHBACK_RULE_FAILURE,
  GET_REWARD_HISTORIES,
  GET_REWARD_HISTORIES_SUCCESS,
  GET_REWARD_HISTORIES_FAILURE,
} from "../ActionTypes";

export const getUserWallet = (id) => ({
  type: GET_USER_WALLET,
  payload: id,
});

export const getUserWalletSuccess = (payload) => ({
  type: GET_USER_WALLET_SUCCESS,
  payload,
});

export const getUserWalletFailure = (payload) => ({
  type: GET_USER_WALLET_FAILURE,
  payload,
});

// 1. Create Funding Intent
export const createFundingIntent = (payload) => ({
  type: CREATE_FUNDING_INTENT,
  payload,
});
export const createFundingIntentSuccess = (payload) => ({
  type: CREATE_FUNDING_INTENT_SUCCESS,
  payload,
});
export const createFundingIntentFailure = (payload) => ({
  type: CREATE_FUNDING_INTENT_FAILURE,
  payload,
});

// 2. Initialize Payment (Get Paystack URL)
export const initializeFundingPayment = (payload) => ({
  type: INITIALIZE_FUNDING_PAYMENT,
  payload,
});
export const initializeFundingPaymentSuccess = (payload) => ({
  type: INITIALIZE_FUNDING_PAYMENT_SUCCESS,
  payload,
});
export const initializeFundingPaymentFailure = (payload) => ({
  type: INITIALIZE_FUNDING_PAYMENT_FAILURE,
  payload,
});

// 3. Verify Payment
export const verifyFundingPayment = (payload) => ({
  type: VERIFY_FUNDING_PAYMENT,
  payload,
});
export const verifyFundingPaymentSuccess = (payload) => ({
  type: VERIFY_FUNDING_PAYMENT_SUCCESS,
  payload,
});
export const verifyFundingPaymentFailure = (payload) => ({
  type: VERIFY_FUNDING_PAYMENT_FAILURE,
  payload,
});

export const getWalletHistory = (payload) => ({
  type: GET_WALLET_HISTORY,
  payload, // payload can contain { wallet_id, page, search, etc. }
});

export const getWalletHistorySuccess = (payload) => ({
  type: GET_WALLET_HISTORY_SUCCESS,
  payload,
});

export const getWalletHistoryFailure = (payload) => ({
  type: GET_WALLET_HISTORY_FAILURE,
  payload,
});

export const getAdminWalletHistory = (payload) => ({
  type: GET_ADMIN_WALLET_HISTORY,
  payload,
});
export const getAdminWalletHistorySuccess = (payload) => ({
  type: GET_ADMIN_WALLET_HISTORY_SUCCESS,
  payload,
});
export const getAdminWalletHistoryFailure = (payload) => ({
  type: GET_ADMIN_WALLET_HISTORY_FAILURE,
  payload,
});
export const processWalletRefund = (payload) => ({
  type: PROCESS_WALLET_REFUND,
  payload,
});
export const processWalletRefundSuccess = (payload) => ({
  type: PROCESS_WALLET_REFUND_SUCCESS,
  payload,
});
export const processWalletRefundFailure = (payload) => ({
  type: PROCESS_WALLET_REFUND_FAILURE,
  payload,
});

export const processWalletReward = (payload) => ({
  type: PROCESS_WALLET_REWARD,
  payload,
});
export const processWalletRewardSuccess = (payload) => ({
  type: PROCESS_WALLET_REWARD_SUCCESS,
  payload,
});
export const processWalletRewardFailure = (payload) => ({
  type: PROCESS_WALLET_REWARD_FAILURE,
  payload,
});
export const getCustomerWallets = (payload) => ({
  type: GET_CUSTOMER_WALLETS,
  payload,
});
export const getCustomerWalletsSuccess = (payload) => ({
  type: GET_CUSTOMER_WALLETS_SUCCESS,
  payload,
});
export const getCustomerWalletsFailure = (payload) => ({
  type: GET_CUSTOMER_WALLETS_FAILURE,
  payload,
});
export const getCashbackRules = (payload) => ({
  type: GET_CASHBACK_RULES,
  payload,
});
export const getCashbackRulesSuccess = (payload) => ({
  type: GET_CASHBACK_RULES_SUCCESS,
  payload,
});
export const getCashbackRulesFailure = (payload) => ({
  type: GET_CASHBACK_RULES_FAILURE,
  payload,
});

export const createCashbackRule = (payload) => ({
  type: CREATE_CASHBACK_RULE,
  payload,
});
export const createCashbackRuleSuccess = (payload) => ({
  type: CREATE_CASHBACK_RULE_SUCCESS,
  payload,
});
export const createCashbackRuleFailure = (payload) => ({
  type: CREATE_CASHBACK_RULE_FAILURE,
  payload,
});

// Notice we accept body (id) and payload
export const updateCashbackRule = (body, payload) => ({
  type: UPDATE_CASHBACK_RULE,
  body,
  payload,
});
export const updateCashbackRuleSuccess = (payload) => ({
  type: UPDATE_CASHBACK_RULE_SUCCESS,
  payload,
});
export const updateCashbackRuleFailure = (payload) => ({
  type: UPDATE_CASHBACK_RULE_FAILURE,
  payload,
});
export const getRewardHistories = (payload) => ({
  type: GET_REWARD_HISTORIES,
  payload,
});
export const getRewardHistoriesSuccess = (payload) => ({
  type: GET_REWARD_HISTORIES_SUCCESS,
  payload,
});
export const getRewardHistoriesFailure = (payload) => ({
  type: GET_REWARD_HISTORIES_FAILURE,
  payload,
});
